import { TenantSlug } from '@/domain/value-object/TenantSlug'
import { TenantCreated } from '@/domain/events/TenantEvents'
import type { ICreateTenantPort, CreateTenantCommand } from '@/application/port/in/ICreateTenantPort'
import type { ITenantRepository } from '@/application/port/out/ITenantRepository'
import type { IDomainEventBus } from '@/application/port/out/IDomainEventBus'
import type { Tenant } from '@/domain/model/Tenant'

export class CreateTenantService implements ICreateTenantPort {
  constructor(
    private readonly tenantRepository: ITenantRepository,
    private readonly eventBus: IDomainEventBus,
  ) {}

  async execute(command: CreateTenantCommand): Promise<Tenant> {
    const slug = TenantSlug.from(command.slug)
    const available = await this.tenantRepository.isSlugAvailable(slug.toString())
    if (!available) throw new Error(`"${slug}" is already taken`)

    const tenant = await this.tenantRepository.create({
      name:        command.name.trim(),
      slug:        slug.toString(),
      ownerUserId: command.ownerUserId,
    })

    await this.eventBus.dispatch([
      new TenantCreated(tenant.id, tenant.slug, tenant.name, command.ownerUserId),
    ])

    return tenant
  }
}
